module.exports = __webpack_public_path__ + "img/f52138b991e0d7a8ef1f279f3167b6d3.png";